import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { FormikField } from '../../../../../Formik'
import {
  LISTING_FORM_FIELD_NAME_PORTALS,
  LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE,
} from '../../../../../RentalPortalListing'
import { useRentalPortalListingsFormPortalsErrorNotification } from '../../RentalPortalListingsForm.hooks'

import { getListingPortalsHintKey } from './PortalsField.utils'
import { PortalsFieldCheckboxGroup } from './PortalsFieldCheckboxGroup'

import * as styles from './PortalsField.module.css'

function PortalsField({
  disabled,
  disabledReason,
  hasPortalsError,
  isLoadingPortals,
  portals,
  onReloadPortals,
  onRemoveNotification,
  onSetNotification,
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  useRentalPortalListingsFormPortalsErrorNotification({
    hasPortalsError,
    onReloadPortals,
    onRemoveNotification,
    onSetNotification,
  })

  const hintKey = getListingPortalsHintKey({
    hasPortalsError,
    hasSchedule: Boolean(values[LISTING_FORM_FIELD_NAME_SCHEDULED_GO_LIVE]),
    isLoading: isLoadingPortals,
    portals,
    selectedPortals: values[LISTING_FORM_FIELD_NAME_PORTALS],
  })

  return hasPortalsError ? null : (
    <FormikField
      Component={PortalsFieldCheckboxGroup}
      disabled={disabled}
      disabledReason={disabledReason}
      fieldComponentProps={{
        className: styles.PortalsField,
        info: hintKey ? t(hintKey) : null,
        label: `${t('RentalPortal.ListingFormPortalsLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      isLoading={isLoadingPortals}
      name={LISTING_FORM_FIELD_NAME_PORTALS}
      portals={portals}
    />
  )
}

export default PortalsField
